import { DefaultTheme } from 'styled-components'

export const lightTheme: DefaultTheme = {
  // Basic
  mode: 'light',
  header: '#4065FA',
  surface: '#FFFFFF',
  background: '#F5F5F5',
  supportIcon: '#F5F5F5',
  progressBar: '#F5F5F5',
  overlay: '#333333',
  faq: '#AAB8EC',
  reviewGrey: '#4F4F4F',

  //Fonts
  darkFont: '#333333',
  mediumFont: '#4F4F4F',
  lightFont: '#6a6767ff',
  blueFont: '#4065FA',
  placeholder: '#B8B8B8',
  headerFont: '#FFFFFF',

  buttonPrimaryFont: '#FFFFFF',

  buttonSecondaryDefault: '#4065FA',
  buttonSecondaryDisabled: '#D9D9D9',
  buttonSecondaryHovered: '#244FF9',
  buttonSecondaryPressed: '#0636F4',

  buttonSecondaryDangerDefault: '#EB0018',
  buttonSecondaryDangerHovered: '#BD0016',
  buttonSecondaryDangerPressed: '#8F0011',

  buttonSecondaryGhostDefault: '#4065FA',
  buttonSecondaryGhostDisabled: '#D9D9D9',
  buttonSecondaryGhostHovered: '#244FF9',
  buttonSecondaryGhostPressed: '#0636F4',

  buttonSecondaryDangerGhostDefault: '#EB001B',
  buttonSecondaryDangerGhostHoverd: '#BD0016',
  buttonSecondaryDangerGhostPressed: '#8F0011',

  // Buttons
  primaryDefault: '#4065FA',
  primaryDisabled: '#D9D9D9',
  primaryHovered: '#244FF9',
  primaryPressed: '#4059BC',

  primaryDangerDefault: '#EB001B',
  primaryDangerDisabled: '#D9D9D9',
  primaryDangerHovered: '#EB001B',
  primaryDangerPressed: '#AD0014',

  buttonSecondaryFont: '#244FF9',

  secondaryDefault: '#FFFFFF',
  secondaryDisabled: '#D9D9D9',
  secondaryHovered: '#C6CDE7',
  secondaryPressed: '#AAB8EC',

  buttonSecondaryDangerFont: '#EB001B',

  secondaryDangerDefault: '#FFFFFF',
  secondaryDangerDisabled: '#D9D9D9',
  secondaryDangerHovered: '#FBCCD1',
  secondaryDangerPressed: '#F799A4',

  // Inputs
  inputBackground: '#F5F5F5',
  inputBorderEmpty: '#B8B8B8',
  inputBorderError: '#EB001B',
  inputBorderActive: '#4065FA',
  inputBorderSaved: '#4F4F4F',

  // Icons
  iconWhite: '#FFFFFF',
  iconLightGrey: '#757575',
  iconDarkGrey: '#4F4F4F',
  iconBlue: '#4065FA',
  greenDark: '#46926D',
  greenTransparent: '#5AF2A9',
  redDark: '#993844',
  redTransparent: '#FF3F57',

  // Signal
  successGreen: '#3B842E',
  successNotificationBackgroundGreen: '#5AF2A980',
  errorRed: '#EB001B',
  errorNotificationBackgroundRed: '#FF3F5780',

  // Logo
  logoBlack: '#000000',
  logoWhite: '#FFFFFF',
  logoPurple: '#6A2FEE',
  logoPink: '#DA1C85',
  logoWhiteTransparent: '#FFFFFF',

  // Report
  reportGrey: '#F0F0F0',

  //Suggenstion
  activeSuggestionBackground: '#D9D9D9',

  // Dev only
  warningYellow: '#FFC76C',
}
